import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';

import Select from 'react-dropdown-select';
import certification from '../assets/images/icons/certification.svg';
import reports from '../assets/images/icons/reports.svg';
import collect_from_home from '../assets/images/icons/collect-from-home.svg';
import Headermain from './Headermain';
import Your_Cart_Box from './Your_Cart_Box';
import cart from '../assets/images/icons/cart-icon.png';
import lab1 from '../assets/images/lab1.png';
import lab2 from '../assets/images/lab2.png';
import lab3 from '../assets/images/lab3.png';
import lab4 from '../assets/images/lab4.png';
import lab5 from '../assets/images/lab5.png';
import lab6 from '../assets/images/lab6.png';
import lab7 from '../assets/images/lab7.png';
import lab8 from '../assets/images/lab8.png';
import lab9 from '../assets/images/lab9.png';
import lab10 from '../assets/images/lab10.png';
import Test_Detail_Listing from './Test_Detail_Listing';
import Footer from './Footer';



class Test_Detail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qty: 0
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Test Detail</title>
                </Helmet>
                <Headermain prop={this.props}/>
                <div className="test-detail-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="test-detail-area">
                                    <h1 className="">Cbc Hemogram Test</h1>
                                    <ul className="info-listing">
                                        <li className="info-listing-col">
                                            <div className="info-listing-box">
                                                <p className="info-heading">Sample Type</p>
                                                <span className="info-text">Blood</span>
                                            </div>
                                        </li>
                                        <li className="info-listing-col">
                                            <div className="info-listing-box">
                                                <p className="info-heading">Processing Time</p>
                                                <span className="info-text">12 hours</span>
                                            </div>
                                        </li>
                                        <li className="info-listing-col">
                                            <div className="info-listing-box">
                                                <p className="info-heading">Special Instruction</p>
                                                <span className="info-text">Fasting is not required</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <p className="description-text">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>

                                    <div className="certification-area">
                                        <ul className="certification-row">
                                            <li className="certification-col">
                                                <div className="certification-box">
                                                    <div className="icon-box">
                                                        <img src={collect_from_home} alt="" />
                                                    </div>
                                                    <p className="title">Collection at your home</p>
                                                </div>
                                            </li>
                                            <li className="certification-col">
                                                <div className="certification-box">
                                                    <div className="icon-box">
                                                        <img src={certification} alt="" />
                                                    </div>
                                                    <p className="title">Certified CAP & NABL Labs</p>
                                                </div>
                                            </li>
                                            <li className="certification-col">
                                                <div className="certification-box">
                                                    <div className="icon-box">
                                                        <img src={reports} alt="" />
                                                    </div>
                                                    <p className="title">Get Reports Quickly</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="test-detail-listing-area">
                                        <h3>Available Labs</h3>
                                        <ul className="test-detail-listing-row">
                                            <Test_Detail_Listing labImgSrc={lab1} testDetailHeading="Toprani Advanced Lab Systems" price="₹350" address="Suflam Appartment, 10, opp. Post office, Haribhakti Colony, Racecourse, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab2} testDetailHeading="Deep Pathology Laboratory" price="₹320" address="111, Avanti Chambers, RC Dutt Rd, Behind Express Hote
                                            Aradhana Society, Vishwas Colony, Alkapuri, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab3} testDetailHeading="Dr Lal PathLabs" price="₹310" address="FF-3, Yajman Complex, Vasna Rd, Near Kalyan Party Plot, Vadodara, 390007" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab4} testDetailHeading="Divine Lab" price="₹310" address="B-201/202 Mangalkriti apt nr. Usupi returant, Fatehgunj, Vadodara, 390002" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab5} testDetailHeading="Shreeji Pathology Laboratory" price="₹320" address="G-10, Kailash Apartment, Gotri Rd, Near Iskcon Temple, Gadapura, Gotri, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab6} testDetailHeading="Yash Laboratory" price="₹320" address="114, Gajanan Complex, Old Padra Rd, Opp. Tube Company, Sheetal Nagar, Akota, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab7} testDetailHeading="Shakti Pathology Lab" price="₹300" address="9, Ground Floor, Harsh Complex, Old Padra Rd, Near Dollar's Avenue, Akota, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab8} testDetailHeading="Akar Diagnostic Lab" price="₹310" address="SB-108, Avishkar Complex, Old Padara Rd, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab9} testDetailHeading="Siddha Pathology Laboratory" price="₹320" address="6,Tarang Society, Opposite Tennis Court Stadium, Akota, Vadodara" linkText="Change Branch" buttonText="Book Now" />

                                            <Test_Detail_Listing labImgSrc={lab10} testDetailHeading="Namra Pathology Laboratory" price="₹300" address="101, Jagannathpuri Complex, New IPCL Rd, Subhanpura, Vadodara" linkText="Change Branch" buttonText="Book Now" />
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <Your_Cart_Box />
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
};

export default Test_Detail;    